import { TenantEntity } from '@/class/model/TenantEntity'

export class CabinManagement extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'CabinManagement'
  }
  get imo() {
    return this._data.imo
  }
  set imo(imo) {
    this._data.imo = imo
  }

  get mblNo() {
    return this._data.mblNo
  }
  set mblNo(mblNo) {
    this._data.mblNo = mblNo
  }

  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }

  get deliveryPlace() {
    return this._data.deliveryPlace
  }
  set deliveryPlace(deliveryPlace) {
    this._data.deliveryPlace = deliveryPlace
  }

  get freeStackDays() {
    return this._data.freeStackDays
  }
  set freeStackDays(freeStackDays) {
    this._data.freeStackDays = freeStackDays
  }

  get freeChestRentPeriod() {
    return this._data.freeChestRentPeriod
  }
  set freeChestRentPeriod(freeChestRentPeriod) {
    this._data.freeChestRentPeriod = freeChestRentPeriod
  }

  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }

  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }

  get allocationStatus() {
    return this._data.allocationStatus
  }
  set allocationStatus(allocationStatus) {
    this._data.allocationStatus = allocationStatus
  }

  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }

  get dischargePort() {
    return this._data.dischargePort
  }
  set dischargePort(dischargePort) {
    this._data.dischargePort = dischargePort
  }

  get loadingPort() {
    return this._data.loadingPort
  }
  set loadingPort(loadingPort) {
    this._data.loadingPort = loadingPort
  }

  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId
  }

  get customerSealDate() {
    return this._data.customerSealDate
  }
  set customerSealDate(customerSealDate) {
    this._data.customerSealDate = customerSealDate
  }

  get customerCutOffTime() {
    return this._data.customerCutOffTime
  }
  set customerCutOffTime(customerCutOffTime) {
    this._data.customerCutOffTime = customerCutOffTime
  }

  get customerWithdrawalDate() {
    return this._data.customerWithdrawalDate
  }
  set customerWithdrawalDate(customerWithdrawalDate) {
    this._data.customerWithdrawalDate = customerWithdrawalDate
  }

  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }

  get sealingDate() {
    return this._data.sealingDate
  }
  set sealingDate(sealingDate) {
    this._data.sealingDate = sealingDate
  }

  get cutOffDate() {
    return this._data.cutOffDate
  }
  set cutOffDate(cutOffDate) {
    this._data.cutOffDate = cutOffDate
  }

  get declarationDate() {
    return this._data.declarationDate
  }
  set declarationDate(declarationDate) {
    this._data.declarationDate = declarationDate
  }

  get guideSellingPrice() {
    return this._data.guideSellingPrice
  }
  set guideSellingPrice(guideSellingPrice) {
    this._data.guideSellingPrice = guideSellingPrice
  }

  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }

  get boxTypeQuantity() {
    return this._data.boxTypeQuantity
  }
  set boxTypeQuantity(boxTypeQuantity) {
    this._data.boxTypeQuantity = boxTypeQuantity
  }

  get voyage() {
    return this._data.voyage
  }
  set voyage(voyage) {
    this._data.voyage = voyage
  }

  get route() {
    return this._data.route
  }
  set route(route) {
    this._data.route = route
  }

  get routeCode() {
    return this._data.routeCode
  }
  set routeCode(routeCode) {
    this._data.routeCode = routeCode
  }

  get routeManager() {
    return this._data.routeManager
  }
  set routeManager(routeManager) {
    this._data.routeManager = routeManager
  }

  get allocationDate() {
    return this._data.allocationDate
  }
  set allocationDate(allocationDate) {
    this._data.allocationDate = allocationDate
  }
  get bookingNo() {
    return this._data.bookingNo
  }
  set bookingNo(bookingNo) {
    this._data.bookingNo = bookingNo
  }
  get plannerDepartment() {
    return this._data.plannerDepartment
  }
  set plannerDepartment(plannerDepartment) {
    this._data.plannerDepartment = plannerDepartment
  }
  get allocationNote() {
    return this._data.allocationNote
  }
  set allocationNote(allocationNote) {
    this._data.allocationNote = allocationNote
  }

  get allocationSerialNumber() {
    return this._data.allocationSerialNumber
  }
  set allocationSerialNumber(allocationSerialNumber) {
    this._data.allocationSerialNumber = allocationSerialNumber
  }

  get cabinSpaceStatus() {
    return this._data.cabinSpaceStatus
  }
  set cabinSpaceStatus(cabinSpaceStatus) {
    this._data.cabinSpaceStatus = cabinSpaceStatus
  }

  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId
  }

  get scNo() {
    return this._data.scNo
  }
  set scNo(scNo) {
    this._data.scNo = scNo
  }

  get shipName() {
    return this._data.shipName
  }
  set shipName(shipName) {
    this._data.shipName = shipName
  }

  get shipEdiCode() {
    return this._data.shipEdiCode
  }
  set shipEdiCode(shipEdiCode) {
    this._data.shipEdiCode = shipEdiCode
  }

  get shipCallSign() {
    return this._data.shipCallSign
  }
  set shipCallSign(shipCallSign) {
    this._data.shipCallSign = shipCallSign
  }

  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent
  }

  get departurePort() {
    return this._data.departurePort
  }
  set departurePort(departurePort) {
    this._data.departurePort = departurePort
  }

  get withdrawalExplanation() {
    return this._data.withdrawalExplanation
  }
  set withdrawalExplanation(withdrawalExplanation) {
    this._data.withdrawalExplanation = withdrawalExplanation
  }

  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales
  }

  get firstAllocationTrustedUnit() {
    return this._data.firstAllocationTrustedUnit
  }
  set firstAllocationTrustedUnit(firstAllocationTrustedUnit) {
    this._data.firstAllocationTrustedUnit = firstAllocationTrustedUnit
  }

  get firstAllocationSales() {
    return this._data.firstAllocationSales
  }
  set firstAllocationSales(firstAllocationSales) {
    this._data.firstAllocationSales = firstAllocationSales
  }

  get dispatchingPlace() {
    return this._data.dispatchingPlace
  }
  set dispatchingPlace(dispatchingPlace) {
    this._data.dispatchingPlace = dispatchingPlace
  }

  get placeOfDeliveryRegion() {
    return this._data.placeOfDeliveryRegion
  }
  set placeOfDeliveryRegion(placeOfDeliveryRegion) {
    this._data.placeOfDeliveryRegion = placeOfDeliveryRegion
  }

  get carrierVoyage() {
    return this._data.carrierVoyage
  }
  set carrierVoyage(carrierVoyage) {
    this._data.carrierVoyage = carrierVoyage
  }

  get voList() {
    return this._data.voList
  }
  set voList(voList) {
    this._data.voList = voList
  }

  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType
  }

  get allocationRemark() {
    return this._data.allocationRemark
  }
  set allocationRemark(allocationRemark) {
    this._data.allocationRemark = allocationRemark
  }

  get transshipment() {
    return this._data.transshipment
  }
  set transshipment(transshipment) {
    this._data.transshipment = transshipment
  }

  get transferPortCode() {
    return this._data.transferPortCode
  }
  set transferPortCode(transferPortCode) {
    this._data.transferPortCode = transferPortCode
  }
}
